import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  primaryText: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

export default useStyles;
